export function isEmpty(str) {
    return !str || str.length === 0;
}

export class pattern {
    static email = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    static phone = /^\d+$/i
}